// extracted by mini-css-extract-plugin
module.exports = {"img_item":"CardDetailImage_img_item__2DE6F"};